import { Link } from 'react-router-dom';
import { EditableText } from '../components/EditableText';
import { SponsorsSection } from '../components/SponsorsSection';
import { TEAMS } from '../data/teams';
import './HomePage.css';

export function HomePage() {
  return (
    <main>
      <section className="hero">
        <div className="hero-inner">
          <h1>SV RUGBY</h1>
          <EditableText
            id="hero-tagline"
            className="hero-tagline"
            defaultValue="Whether you're a rugby vet or completely new to the sport, we have a place for you."
          />
          <Link to="/contact" className="hero-cta">
            Join Us
          </Link>
        </div>
      </section>

      <section id="about" className="about">
        <div className="section-inner">
          <span className="kicker">Welcome</span>
          <h2>Silicon Valley Rugby</h2>
          <div className="about-grid">
            <div className="about-block">
              <h3>About</h3>
              <EditableText id="about-body" defaultValue="TODO - add About copy." />
            </div>
            <div className="about-block">
              <h3>Mission</h3>
              <EditableText id="mission-body" defaultValue="TODO - add Mission copy." />
            </div>
          </div>
        </div>
      </section>

      <section id="teams" className="teams">
        <div className="section-inner">
          <h2>Teams</h2>
          <p className="section-subcopy">Our club has a team for everyone. Find yours today.</p>
          <div className="teams-grid">
            {TEAMS.map((team) => (
              <div className="team-card" key={team.slug}>
                <h3>{team.name}</h3>
                <EditableText id={team.contentId} defaultValue={team.description} />
                <Link to={`/contact/${team.slug}`} className="team-cta">
                  Enroll Now
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SponsorsSection />
    </main>
  );
}
